export function zoneColor(H) {
    H.wrap(H.Series.prototype, 'getAttribs', function (proceed) {
        const series = this;
        series.zones.forEach(zone => {
            if (zone.getColor) {
                zone.color = zone.fillColor = zone.getColor(series);
            }
        });
        return proceed.apply(series, Array.prototype.slice.call(arguments, 1));
    });
}
//# sourceMappingURL=zone-color.js.map